import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { userApiClient } from '../../userApiClient';
import { PassWalletDetail } from '../../models/Pass';
import PassInstanceDetailsView from '../../components/passes/PassInstanceDetailsView';

export default function UserPassDetailsPage() {
  const { passId } = useParams<{ passId: string }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [pass, setPass] = useState<PassWalletDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPass = useCallback(async () => {
    if (!passId) return;
    try {
      setLoading(true);
      setError(null);
      const data = await userApiClient.getWalletPass(passId);
      setPass(data);
    } catch (err) {
      console.error(`Error fetching wallet pass ${passId}:`, err);
      setError(t('userPasses.details.fetchError', 'Failed to load this pass'));
    } finally {
      setLoading(false);
    }
  }, [passId, t]);

  useEffect(() => {
    fetchPass();
  }, [fetchPass]);

  return (
    <PassInstanceDetailsView
      audience="user"
      pass={pass}
      loading={loading}
      error={error}
      backLabel={t('userPasses.details.backToPasses', 'Back to my passes')}
      onBack={() => navigate('/user/passes')}
    />
  );
}
